<div class="loading center">
  <div class="loading-midd">
    <i class="fa fa-circle-o-notch fa-spin"></i> Loading
  </div>
</div>
